import wysiegnik from '@components/search/inputs/wysiegnik'
import lemiesz from '@components/search/inputs/lemiesz'
import dlugosc from '@components/search/inputs/dlugosc'
import szerokosc from '@components/search/inputs/szerokosc'
import waga from '@components/search/inputs/waga'
import colors, { colorNames } from '@constants/values/colors'

const nadwozieBudowlany = { t: 'Nadwozie', inputs: [
    wysiegnik,
    lemiesz,
    dlugosc,
    szerokosc,
    waga,
    { t: 'Wysokość podnoszenia', type: 'range', name: 'wysokosc-podnoszenia', unit: 'cm', small: true },
    { t: 'Udźwig', type: 'range', name: 'udzwig', unit: 'kg' },
    { t: 'Pojemność łyżki', type: 'range', name: 'pojemnosc-lyzki', unit: 'm³' },
    { t: 'Masa eksloatacyjna', type: 'range', name: 'masa-eksploatacyjna', unit: 'T', small: true },
    { t: 'Szerokość gąsienic', type: 'range', name: 'szerokosc-gasienic', unit: 'mm' },
    { t: 'Głębokość kopania', type: 'range', name: 'glebokosc-kopania', unit: 'm' },
    { t: 'Szerokość lemiesza', type: 'range', name: 'szerokosc-lemiesza', unit: 'm' },
    { t: 'Liczba miejsc', type: 'range',  name: 'liczba-miejsc', hint: { url: '/seats' }},
    { t: 'Kolor', type: 'multi-checkbox', name: 'kolor', options: colors, names: colorNames },
]}

export default nadwozieBudowlany